<template>
    <div class="app-header bg-zinc-800">
        <layout-contained>
            <div class="flex justify-between py-4 text-2xl">
                <nuxt-link :aria-label="$config.public.siteName" to="/">
                    <picture>
                        <source :srcset="$config.public.images + $config.public.siteLogoAvif" type="image/avif" media />
                        <source :srcset="$config.public.images + $config.public.siteLogoWebp" type="image/webp" media />
                        <img :src="$config.public.images + $config.public.siteLogo" width="174" height="43" alt />
                    </picture>
                </nuxt-link>
                <div class="grow"></div>
                <app-header-menu></app-header-menu>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
};
</script>
